// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 1025px)";
var _4 = "wrapper-kWcIe";
var _5 = "title-1teBB";
var _6 = "content__text-9eKa_";
var _7 = "link-2YgQh";
export { _1 as "__esModule", _2 as "mobile", _3 as "laptop", _4 as "wrapper", _5 as "title", _6 as "content__text", _7 as "link" }
export default { "__esModule": _1, "mobile": _2, "laptop": _3, "wrapper": _4, "title": _5, "content__text": _6, "link": _7 }
